'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reloadLayer = reloadLayer;

var _FrameActions = require('../frame/FrameActions');

/**
 * Přenačte vrstvu.
 *
 * @param area - oblast store
 * @param id - ID vrstvy
 */
function reloadLayer(area, id) {
  return (0, _FrameActions.postMessage)(area, { type: 'REALOAD_LAYER', id: id });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvbWFwaW8vTWFwQWN0aW9ucy5qc3giXSwibmFtZXMiOlsicmVsb2FkTGF5ZXIiLCJhcmVhIiwiaWQiLCJ0eXBlIl0sIm1hcHBpbmdzIjoiOzs7OztRQVFnQkEsVyxHQUFBQSxXOztBQVJoQjs7QUFFQTs7Ozs7O0FBTU8sU0FBU0EsV0FBVCxDQUFxQkMsSUFBckIsRUFBbUNDLEVBQW5DLEVBQStDO0FBQ2xELFNBQU8sK0JBQVlELElBQVosRUFBa0IsRUFBQ0UsTUFBTSxlQUFQLEVBQXdCRCxNQUF4QixFQUFsQixDQUFQO0FBQ0giLCJmaWxlIjoiTWFwQWN0aW9ucy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7cG9zdE1lc3NhZ2V9IGZyb20gJy4uL2ZyYW1lL0ZyYW1lQWN0aW9ucyc7XG5cbi8qKlxuICogUMWZZW5hxI10ZSB2cnN0dnUuXG4gKlxuICogQHBhcmFtIGFyZWEgLSBvYmxhc3Qgc3RvcmVcbiAqIEBwYXJhbSBpZCAtIElEIHZyc3R2eVxuICovXG5leHBvcnQgZnVuY3Rpb24gcmVsb2FkTGF5ZXIoYXJlYTogc3RyaW5nLCBpZDogc3RyaW5nKSB7XG4gICAgcmV0dXJuIHBvc3RNZXNzYWdlKGFyZWEsIHt0eXBlOiAnUkVBTE9BRF9MQVlFUicsIGlkfSk7XG59XG4iXX0=